import { useDispatch, useSelector } from 'react-redux';
import { useNativeLang } from './useNativeLang';
import { useEffect } from 'react';
import { translate } from '../ducks/translation.duck';

const extract = (translations, lang, batchId) => {
  return translations?.[lang]?.[batchId]?.translation;
};

export function useTranslation({ batchId, translationEntries }) {
  const { userNativeLang } = useNativeLang();
  const dispatch = useDispatch();
  const translation = useSelector(state => state.translation);
  const { translations, translationInProgress, translationErr } = translation;
  const batchTranslations = extract(translations, userNativeLang, batchId) ?? translationEntries;
  useEffect(() => {
    dispatch(translate({ lang: userNativeLang, batchId, data: translationEntries }));
  }, [userNativeLang, batchId]);

  return { translation: batchTranslations, translationInProgress, translationErr };
}
